var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 10.5,
    viewBox: "0 0 14.5 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_12",
    "data-name": "\\uD569\\uCE58\\uAE30 12",
    d: "M110.5,4417l6.5,9Zm0,0-6.5,9Z",
    transform: "translate(-103.25 -4416.25)",
    fill: "none",
    stroke: "#333",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBig);
export default __webpack_public_path__ + "static/media/arrow_big.17cb9e595c08ed6dc0a8a13ad6c94ed5.svg";
export { ForwardRef as ReactComponent };